module.exports = __webpack_public_path__ + "static/img/banner.af6161e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因调控/基因检测panel定制及SNP分型/banner.png
// module id = HZS0
// module chunks = 16